// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bermuda from '../_raw/flag/icon_flag_bermuda.png';

export default () => <img src={Bermuda} alt="Bermuda" />;
